module.exports = __webpack_public_path__ + "static/media/spenmo-desktop.f1fefa82.svg";